import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure
} from './penalty-fee.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { PenaltyFeeService } from './penalty-fee.service';

@Injectable()
export class PenaltyFeeRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap(() => {
                const url = 'penalty-fee';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        
                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchSingleRecordSuccess({listData: data.records});

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/service-fee");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data: any) => {
                const url = 'penalty-fee';
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return updateRecordSuccess({singleData: response.data?.record});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'penalty-fee/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        public helperService: HelperService,
        public moduleService: PenaltyFeeService
    ) { }

}